import { use } from 'react'

import { LocaleContext, LOCALES } from '@/lib/locale'

/** The current language (`'en'` or `'ar'`) and `toggle()` to switch it. */
export const useLocale = () => use(LocaleContext)

/** The current language's copy: every export of `@/data/<locale>`. */
export const useData = () => LOCALES[use(LocaleContext).locale].data
